import * as React from "react"
import parse from "html-react-parser"
import { StaticImage } from "gatsby-plugin-image"
import { handleResourcesImages } from "../../hooks/handleResourcesImages"

import "./table_of_contents.scss"

          const TableOfContents = ({sectionContent}) => {
            return (
                <div className="toc stickydiv">
              <div className="resources-table-of-contents">
                <section className="toc-header">
                {handleResourcesImages("toc-dots")}
                  <div className="">
                      <h2><span className="checkmark align-middle"> {handleResourcesImages("square-check")}</span>Table of Contents</h2>
                  </div>
                </section>
                <section className="toc-content ">
                {parse(sectionContent)}
                
                <div className="text-center">
                <a href="/demo"><button className="text-light white-cta-button p-2">Schedule A Demo
                    <StaticImage
            loading="eager"
              className="white-right-arrow"
              layout="fixed"
              src="../../images/right-arrow.png"
              width={15}
              quality={100}
              alt="Right arrow"
          /></button></a>
          </div>
                </section>           
              </div>
              </div>
            )
          }
  
  export default TableOfContents
  